<template>
  <div>
    <div class="index_banner_box">
      <carousel :imgList="bannerList" @bannerdetail="bannerdetail"></carousel>
      <!-- <el-carousel :interval="10000" arrow="never" height="540px">
        <el-carousel-item
          @click="bannerdetail(item.chainedAddress)"
          v-for="item in bannerList"
          :key="item.bannerId"
        >
          <el-image
            @click="bannerdetail(item.chainedAddress)"
            :style="
              item.chainedAddress
                ? 'cursor: pointer;height: 540px; width: 100%;'
                : 'height: 540px; width: 100%;'
            "
            :src="item.imagePath"
          ></el-image>
        </el-carousel-item>
      </el-carousel> -->
    </div>
    <div class="index_con_box2c">
      <div class="index_title1">
        <p class="title">书系介绍</p>
        <div class="title_box" v-if="OclexueResourceData2.length">
          <div class="title_box1">
            <img src="../../../assets/icon/lx_index1.png" alt="" class="icon" />
            <p>正版书增值服务课程</p>
          </div>
          <div class="more_btn" @click="toMoreList('particular')">
            <span>查看更多</span>
            <img src="../../../assets/icon/indexico_to.png" alt="" />
          </div>
        </div>
        <div class="goods_card_list">
          <div
            class="goods_card"
            v-for="(item, index) in OclexueResourceData2"
            :key="index"
            @mouseenter="mouseenterCar(index)"
            @mouseleave="hoverCardIndex = null"
            @click="toDetail(item.resourceId, item.resourceType)"
          >
            <div :class="hoverCardIndex === index ? 'hoverCard_sty' : ''">
              <div class="img_box">
                <img :src="item.resourceCover" alt="" />
              </div>
              <div class="goods_box">
                <p class="name">{{ item.resourceName }}</p>
                <div class="tagList">
                  <div
                    v-for="(items, indexs) in item.keyword.split(',')"
                    :key="indexs"
                  >
                    {{ items }}
                  </div>
                </div>
                <div class="detail_num">
                  <p>
                    共{{ item.courseNumber || "0" }}节课
                    {{ item.paperNumber || "0" }}套题
                  </p>
                  <div class="viewerNumber">
                    <img src="../../../assets/icon/eye.png" alt="" />
                    <span>{{ item.viewerNumber | formatNumber }}</span>
                  </div>
                </div>
                <button
                  class="code_input"
                  v-if="hoverCardIndex === index"
                  @click.stop="boundCodeShow(item.resourceId, item.authCode)"
                >
                  <!-- {{ item.authCode != "0" ? "输入授权码" : "去看课" }} -->
                  去看课
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="title_box" v-if="OclexueResourceData.length">
          <div class="title_box1">
            <img src="../../../assets/icon/lx_index2.png" alt="" class="icon" />
            <p>四套卷</p>
          </div>
          <div class="more_btn" @click="toMoreList('specialMark')">
            <span>查看更多</span>
            <img src="../../../assets/icon/indexico_to.png" alt="" />
          </div>
        </div>
        <div class="paper_card_list">
          <div
            class="paper_card"
            v-for="(item, index) in OclexueResourceData"
            :key="index"
            @click="toDetail(item.resourceId, item.resourceType)"
          >
            <img :src="item.resourceCover" alt="" />
            <div class="info_box">
              <div class="name">{{ item.resourceName }}</div>
              <div class="tagList">
                <div
                  v-for="(items, indexs) in item.keyword.split(',')"
                  :key="indexs"
                >
                  {{ items }}
                </div>
              </div>
              <div class="price">
                <p>{{ item.realPrice | tofixed2("￥") }}</p>
                <span v-if="item.prices > 0">{{
                  item.prices | tofixed2("￥")
                }}</span>
              </div>
              <div class="viewerNumber">
                <p>
                  共{{ item.courseNumber || "0" }}节课
                  {{ item.paperNumber || "0" }}套题
                </p>
                <div>
                  <img src="../../../assets/icon/eye.png" alt="" />
                  <span>{{ item.viewerNumber | formatNumber }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <noData
          v-if="!OclexueResourceData.length && !OclexueResourceData2.length"
        ></noData>

        <div class="contact_box">
          <img src="../../../assets/icon/phone_01.png" alt="" />
          <span>如有疑问请拨打010-68182527咨询</span>
        </div>
        <!-- <div class="video_mode">
          <p class="title">视频文章</p>
          <div class="video_box">
            <div class="title_box">
            <div class="title_box1">
              <img src="../../../assets/icon/lx_index3.png" alt="" class="icon" />
              <p>短视频</p>
            </div>
            <div class="more_btn">
              <span>查看更多</span>
              <img src="../../../assets/icon/indexico_to.png" alt="" />
            </div>
          </div>
          </div>
        </div> -->
      </div>
    </div>
    <boundCode
      :show="boundCodeState"
      :resourceId="resourceIdCode"
      @close="boundCodeClose"
      @succeed="boundCodeClose"
    ></boundCode>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  GetBannerList,
  SelectOclexueResource,
} from "@/api/willingLearn/index.js";
import carousel from "@/components/carousel.vue";
import noData from "@/components/noData.vue";
import boundCode from "@/views/willingLearn/bookstore/boundCode/index.vue";
export default {
  components: { noData, boundCode, carousel },
  computed: {
    ...mapGetters(["token"]),
  },
  data() {
    return {
      classifyId: "",
      bannerList: [],
      OclexueResourceData: [],
      OclexueResourceData2: [],
      hoverCardIndex: null,
      boundCodeState: false,
      resourceIdCode: "",
    };
  },
  mounted() {
    this.classifyId = this.$route.query ? this.$route.query.id : "";
    this.getbannerList();
    this.getOclexueResource();
    // this.getVideoResource()
    console.log(this.$route.query.id, 1111);
  },
  watch: {},
  methods: {
    getbannerList() {
      GetBannerList({
        pageNum: 1,
        pageSize: 10,
        addressType: "weblexue",
      }).then((res) => {
        this.bannerList = res.data;
      });
    },
    bannerdetail(to) {
      //如果轮播图有对应的链接就去跳转
      if (to) {
        window.open(to, "_blank");
      }
    },
    getOclexueResource() {
      setTimeout(() => {
        SelectOclexueResource({
          resourceType: this.classifyId,
          keyword: "",
          specialMark: "dollors", //特殊标记
        }).then((res) => {
          this.OclexueResourceData = res.rows.slice(0, 2);
        });
      }, 200);
      let myDate = new Date();
      SelectOclexueResource({
        resourceType: this.classifyId,
        keyword: "",
        // particular: myDate.getFullYear(), //当前年份
        particular: "2025", //当前年份
      }).then((res) => {
        this.OclexueResourceData2 = res.rows.slice(0, 8);
      });
    },
    // 视频文章
    getVideoResource() {
      SelectShortVideoList().then((res) => {
        console.log(res.rows);
      });
      SelectArticleList().then((res) => {
        console.log(res.rows);
      });
    },
    // 鼠标移入
    mouseenterCar(index) {
      this.hoverCardIndex = index;
    },

    // 点击容器进入页面
    toDetail(id, type) {
      this.$router.push({
        path: "/willingLearn/bookstoreDetail",
        query: {
          goodsId: id,
          goodsType: type,
        },
      });
    },
    // 跳书系列表
    toMoreList(type) {
      this.$router.push({
        path: "/willingLearn/bookstore",
        query: {
          type: type,
        },
      });
    },
    boundCodeShow(resourceId, authCode) {
      // if (this.token) {
      //   if (authCode != "0") {
      //     this.resourceIdCode = resourceId;
      //     this.boundCodeState = true;
      //   } else {
      //     this.$router.push({
      //       path: "/willingLearn/courseQuestions",
      //       query: {
      //         goodsId: resourceId,
      //       },
      //     });
      //   }

      if (this.token) {
        this.resourceIdCode = resourceId;
        this.$router.push({
          path: "/willingLearn/courseQuestions",
          query: {
            goodsId: resourceId,
          },
        });
      } else {
        this.$router.push("/login");
      }
    },
    boundCodeClose() {
      this.boundCodeState = false;
    },
  },
};
</script>
<style scoped lang="scss">
.index_banner_box {
  width: 100%;
  min-width: 1400px;
  height: 540px;
  position: relative;
  z-index: 0;
}
.index_title1 .title {
  position: relative;
  display: table;
  margin: 50px auto;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

.index_title1 .title:before {
  position: absolute;
  content: "";
  width: 80px;
  height: 4px;
  background: #2e9adb;
  border-radius: 2px;
  left: 50%;
  transform: translateX(-50%);
  bottom: -13px;
}
.index_con_box2c {
  width: 1400px;
  margin: 0 auto;
}
.title_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 25px 0;
  .title_box1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .icon {
    margin-right: 4px;
    height: 25px;
  }
  span {
    float: right;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.more_btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    margin-left: 4px;
  }
}
.goods_card_list {
  display: grid;
  grid-row-gap: 20px;
  grid-column-gap: 30px;
  padding: 0;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: start;
  grid-template-columns: repeat(auto-fit, 327px);
}
.goods_card {
  width: 332px;
  height: 483px;
  border-radius: 6px;
  cursor: pointer;
  .img_box {
    width: 100%;
    height: 331px;
    background-color: #fbfbfb;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #f2f2f2;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 237px;
    }
  }
  .goods_box {
    padding: 0 20px;
    height: 134px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    background-color: #fff;
    // border-bottom: 1px solid #f2f2f2;
    .name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    .tagList {
      height: 28px;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      div {
        min-width: 60px;
        max-width: 100px;
        height: 28px;
        background-color: #f2f2f2;
        padding: 0 10px;
        display: block;
        line-height: 28px;
        margin-right: 16px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        text-align: center;
      }
    }
    .detail_num {
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #2e9adb;
      }
      .viewerNumber {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }
    }
    .code_input {
      width: 200px;
      height: 40px;
      border: 2px solid #2e9adb;
      border-radius: 10px;
      color: #2e9adb;
      background-color: #fff;
      margin: 0 auto;
      cursor: pointer;
    }
  }
}
.hoverCard_sty {
  height: 483px;
  margin-top: -10px;
  background: linear-gradient(0deg, #ffffff, #ffffff, #388cfc);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  transition: all 0.3s;
  .goods_box {
    height: 154px;
  }
}
.paper_card_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .paper_card {
    width: 680px;
    height: 240px;
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 21px;
    display: flex;
    box-sizing: border-box;
    background: url("../../../assets/icon/bgindex_01.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    img {
      width: 199px;
      height: 199px;
      margin-right: 20px;
    }
    .info_box {
      height: 199px;
      max-width: 420px;
      .name {
        font-size: 18px;
        height: 50px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /*行数*/
        -webkit-box-orient: vertical;
      }
      .tagList {
        height: 28px;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        margin: 24px 0;
        div {
          min-width: 60px;
          max-width: 100px;
          height: 28px;
          background-color: #f2f2f2;
          padding: 0 10px;
          display: block;
          line-height: 28px;
          margin-right: 16px;
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          text-align: center;
        }
      }
      .price {
        display: flex;
        align-items: center;
        padding-bottom: 19px;
        p {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ff5353;
          margin-right: 10px;
        }
        span {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          text-decoration: line-through;
          color: #b6b6b6;
        }
      }
      .viewerNumber {
        display: flex;
        align-items: center;
        p {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #2e9adb;
          margin-right: 50px;
        }
        div {
          display: flex;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
            margin-right: 4px;
          }
          span {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
      }
    }
  }
}
.contact_box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 42px 0 31px;
  img {
    width: 15px;
    height: 17px;
    margin-right: 8px;
  }
  span {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
  }
}
.video_mode {
  background-color: #fbfbfb;
  .video_box {
    width: 840px;
    // height: 650px;
  }
}
</style>
